import Filter from './Filter'

export default class ApplyDocument extends Filter {
    filterComponent = import('@/views/components/filters/compoents/ApplyDocFilterComponent.vue')

    static DC_TYPE = 'dc_type'

    static STATUS = 'status'

    static REGION = 'region'

    static ORGANIZATION = 'organization'

    static DIRECTION = 'direction'

    static IS_PRIORITY = 'is_priority'

    static PERIOD = 'quarter__period__id'

    static QUARTER = 'quarter'

    static GENDER = 'gender'

    static SCHOLARSHIP_STATUS = 'scholarship_status'

    static ADVISOR = 'advisor'

    static COURSE = 'course'

    static MONITORING_1 = 'monitoring_1'

    static MONITORING_2 = 'monitoring_2'

    static MONITORING_3 = 'monitoring_3'

    static IS_OLD = 'is_old'

    static IS_OLD_CONFIRM = 'is_old_confirmed'

    static EXEL_GENERATE_ENDPOINT = '/statistics/apply_docs_exel'

    fields = {
      [ApplyDocument.DC_TYPE]: {
        label: 'Dc Type',
      },
      [ApplyDocument.STATUS]: {
        label: 'Status',
      },
      [ApplyDocument.REGION]: {
        label: 'Regions',
      },
      [ApplyDocument.ORGANIZATION]: {
        label: 'Universities',
      },
      [ApplyDocument.DIRECTION]: {
        label: 'Direction',
      },
      [ApplyDocument.IS_PRIORITY]: {
        label: 'Ustuvor',
      },
      [ApplyDocument.PERIOD]: {
        label: 'Period',
      },
      [ApplyDocument.QUARTER]: {
        label: 'Quarter',
      },
      [ApplyDocument.GENDER]: {
        label: 'Gender',
      },
      [ApplyDocument.SCHOLARSHIP_STATUS]: {
        label: 'Scholarship Status',
      },
      [ApplyDocument.ADVISOR]: {
        label: 'Research Advisor',
      },
      [ApplyDocument.COURSE]: {
        label: 'Course',
      },
      [ApplyDocument.MONITORING_1]: {
        label: 'monitoring_1',
      },
      [ApplyDocument.MONITORING_2]: {
        label: 'monitoring_2',
      },
      [ApplyDocument.MONITORING_3]: {
        label: 'monitoring_3',
      },
      [ApplyDocument.MONITORING_3]: {
        label: 'monitoring_3',
      },
      [ApplyDocument.IS_OLD]: {
        label: 'IS_OLD_LABEL',
      },
      [ApplyDocument.IS_OLD_CONFIRM]: {
        label: 'IS_OLD_CONFIRM_LABEL',
      },
    }
}
